import React from 'react'

const MainHero = () => {
  return (
    <>

      <div className="rn-hero-area ">
        <div className="maincontainer">
          <div className="herocontainer">
            <div className=" text-left">
              <h1 className="title-1">Lorem ipsum dolor sit amet</h1>
              <div className='hero-para'>

                <p className="para-1">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
              </div>

            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default MainHero;